export * from "./stepKeys";
export * from "./stepConfig";

export const GOOGLE_MAP_URL = "https://maps.google.com/maps/api/geocode/json";



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/consts/index.js